module.exports = {"150785001":"河东街道","150785002":"河西街道","150785003":"森工街道","150785004":"好里堡街道","150785101":"金河镇","150785102":"阿龙山镇","150785103":"满归镇","150785104":"得耳布尔镇","150785200":"敖鲁古雅鄂温克民族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150785.json
// module id = 546
// module chunks = 0